module.exports = __webpack_public_path__ + "static/media/thank_you_wallpaper_mobile.2ee414a4.png";